<nav class="tamis-sidebar" [class.collapsed]="isCollapsed"
  *ngIf="userRole != null && userRole !== roles.PATIENT && isLoggedIn">

  <!-- Logo + Collapse Button -->
  <div class="sidebar-header">
    <img src="../../../assets/images/tamis_logo.png" class="logo-header" *ngIf="!isCollapsed">
    <button class="collapse-btn" (click)="toggleSidebar()"
      [matTooltip]="isCollapsed ? 'Expandir menu' : 'Recolher menu'" matTooltipPosition="right">
      <mat-icon>{{ isCollapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
    </button>
  </div>

  <!-- Navigation Links -->
  <div class="sidebar-nav">
    <ng-container *ngIf="userRole === roles.MEMBER">
      <button class="nav-item" [class.active]="isNavbarItemActive('patient')" (click)="navbarRouter('patient')"
        [matTooltip]="isCollapsed ? 'Pacientes' : ''" matTooltipPosition="right">
        <mat-icon>people</mat-icon>
        <span class="nav-label">Pacientes</span>
      </button>

      <button class="nav-item" [class.active]="isNavbarItemActive('visits')" (click)="navbarRouter('visits')"
        [matTooltip]="isCollapsed ? 'Visitas' : ''" matTooltipPosition="right">
        <mat-icon>event_note</mat-icon>
        <span class="nav-label">Visitas</span>
      </button>

      <button class="nav-item"
        [class.active]="isNavbarItemActive('health-member/list') || isNavbarItemActive('health-member/detail') || isNavbarItemActive('health-member/register')"
        (click)="navbarRouter('member')" [matTooltip]="isCollapsed ? 'Membros' : ''" matTooltipPosition="right">
        <mat-icon>group</mat-icon>
        <span class="nav-label">Membros</span>
      </button>

      <button class="nav-item" [class.active]="isNavbarItemActive('medicine')" (click)="navbarRouter('medicine')"
        [matTooltip]="isCollapsed ? 'Prescrições Médicas' : ''" matTooltipPosition="right">
        <mat-icon>medical_services</mat-icon>
        <span class="nav-label">Prescrições Médicas</span>
      </button>

      <button class="nav-item" [class.active]="isNavbarItemActive('form')" (click)="navbarRouter('form')"
        [matTooltip]="isCollapsed ? 'Questionários' : ''" matTooltipPosition="right">
        <mat-icon>assignment</mat-icon>
        <span class="nav-label">Questionários</span>
      </button>

      <button class="nav-item" [class.active]="isNavbarItemActive('care-plan')" (click)="navbarRouter('carePlan')"
        [matTooltip]="isCollapsed ? 'Plano de cuidados' : ''" matTooltipPosition="right">
        <mat-icon>favorite</mat-icon>
        <span class="nav-label">Plano de cuidados</span>
      </button>

      <button class="nav-item" [class.active]="isNavbarItemActive('dashboard')" (click)="navbarRouter('dashboard')"
        [matTooltip]="isCollapsed ? 'Dashboard' : ''" matTooltipPosition="right">
        <mat-icon>dashboard</mat-icon>
        <span class="nav-label">Dashboard</span>
      </button>

      <button class="nav-item" [class.active]="isNavbarItemActive('tamis-bot')" (click)="navbarRouter('tamis-bot')"
        [matTooltip]="isCollapsed ? 'Tamis IA' : ''" matTooltipPosition="right">
        <mat-icon>smart_toy</mat-icon>
        <span class="nav-label">Tamis IA</span>
      </button>
    </ng-container>

    <button class="nav-item" *ngIf="userRole !== roles.MEMBER"
      [class.active]="isNavbarItemActive('health-member/list') || isNavbarItemActive('health-member/detail') || isNavbarItemActive('health-member/register')"
      (click)="navbarRouter('member')" [matTooltip]="isCollapsed ? 'Membros' : ''" matTooltipPosition="right">
      <mat-icon>group</mat-icon>
      <span class="nav-label">Membros</span>
    </button>

    <ng-container *ngIf="userRole === roles.ADMIN || userRole === roles.MEMBER">
      <div class="nav-divider" *ngIf="!isCollapsed"></div>
      <button class="nav-item" [class.active]="isNavbarItemActive('admin-configuration')"
        (click)="navbarRouter('adminConfigurations')" [matTooltip]="isCollapsed ? 'Configurações' : ''"
        matTooltipPosition="right">
        <mat-icon>settings</mat-icon>
        <span class="nav-label">Configurações</span>
      </button>
    </ng-container>

    <ng-container *ngIf="userRole === roles.IGESTO_ADMIN">
      <button class="nav-item" [class.active]="isNavbarItemActive('institution')" (click)="navbarRouter('institution')"
        [matTooltip]="isCollapsed ? 'Instituição' : ''" matTooltipPosition="right">
        <mat-icon>business</mat-icon>
        <span class="nav-label">Instituição</span>
      </button>
      <button class="nav-item" [class.active]="isNavbarItemActive('configuration')"
        (click)="navbarRouter('configuration')" [matTooltip]="isCollapsed ? 'Configuração' : ''"
        matTooltipPosition="right">
        <mat-icon>tune</mat-icon>
        <span class="nav-label">Configuração</span>
      </button>
    </ng-container>
  </div>

  <!-- Bottom: Institution + User -->
  <div class="sidebar-footer">
    <div class="institution-wrapper" *ngIf="!isCollapsed">
      <mat-spinner *ngIf="isLoading" class="spinner-center" color="accent" diameter="22"
        mode="indeterminate"></mat-spinner>
      <mat-form-field *ngIf="!isLoading" appearance="legacy" class="institution-select">
        <mat-select [(ngModel)]="selectedInstitutionId" (selectionChange)="onInstitutionChange($event)">
          <mat-option *ngFor="let institution of institutions" [value]="institution.id">
            {{institution.nome}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="user-footer">
      <app-logged-user-info (onSignOut)="signOut()" [userName]="userName"
        [showName]="!isCollapsed"></app-logged-user-info>
    </div>
  </div>
</nav>

<!-- Patient Sidebar -->
<nav class="tamis-sidebar" [class.collapsed]="isCollapsed" *ngIf="userRole === roles.PATIENT && isLoggedIn">

  <div class="sidebar-header">
    <img src="../../../assets/images/tamis_logo.png" class="logo-header" *ngIf="!isCollapsed">
    <button class="collapse-btn" (click)="toggleSidebar()"
      [matTooltip]="isCollapsed ? 'Expandir menu' : 'Recolher menu'" matTooltipPosition="right">
      <mat-icon>{{ isCollapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
    </button>
  </div>

  <div class="sidebar-nav">
    <button class="nav-item" *ngIf="isPatientFullRegistered" [class.active]="isNavbarItemActive('user')"
      (click)="navbarRouter('user')" [matTooltip]="isCollapsed ? 'Dados Cadastrais' : ''" matTooltipPosition="right">
      <mat-icon>person</mat-icon>
      <span class="nav-label">Dados Cadastrais</span>
    </button>

    <button class="nav-item" *ngIf="isPatientFullRegistered" [class.active]="isNavbarItemActive('patient-visits')"
      (click)="navbarRouter('patient-visits')" [matTooltip]="isCollapsed ? 'Visitas' : ''" matTooltipPosition="right">
      <mat-icon>event_note</mat-icon>
      <span class="nav-label">Visitas</span>
    </button>
  </div>

  <div class="sidebar-footer">
    <div class="user-footer">
      <mat-spinner *ngIf="isLoading" class="spinner-center" diameter="22" color="accent"
        mode="indeterminate"></mat-spinner>
      <app-logged-user-info *ngIf="!isLoading" (onSignOut)="signOut()" [userName]="userName"
        [showName]="!isCollapsed"></app-logged-user-info>
    </div>
  </div>
</nav>